import { gql } from '@apollo/client'

export const promoCodeFields = `
id
code
type
value
protected
`

export const getPromoCode = gql`
query GetPromoCode($code: String!) {
  getPromoCode(code: $code) {
    id
    code
    type
    value
  }
}
`
